// @ts-strict-ignore
import { readCookieRaw } from '@u/cookies'
import { createPayloadAction } from '@r/helpers/redux-helpers'
import { FsCore } from '../../types/fs-core'

const { __FS_API_URL__ } = global

export interface UpdateProfilePayload {
  profile?: FsCore.Profile
  profileNotFound?: boolean
  dobRequired?: boolean
  dobWrong?: boolean
}
export const updateDeviceProfile =
  createPayloadAction<UpdateProfilePayload>('UPDATE_DEVICE_PROFILE')

export const setBadCreditCardResult = createPayloadAction<{ isCreditScoreBad: boolean }>(
  'SET_BAD_CREDIT_CARD_SCORE',
)

export const setHasUserCompletedEC = createPayloadAction<{ hasUserCompletedEC: boolean }>(
  'SET_HAS_USER_COMPLETED_EC',
)

export const profileRequest = (brand: string, dob: string) => {
  return fetch(
    `${__FS_API_URL__}/profile?brand=${brand}&deviceId=${readCookieRaw('uscd')}${
      dob ? `&dob=${dob}` : ''
    }`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

const FORBIDDEN = 403
const NOT_FOUND = 404
const SERVER_ERROR = 500

export const fetchDeviceProfile = (brand: string, dob: string) => {
  return async (dispatch: any) => {
    const response = await profileRequest(brand, dob)
    if (response.status >= SERVER_ERROR) {
      throw new Error('Error from FS-API')
    } else if (response.status === FORBIDDEN) {
      dispatch(updateDeviceProfile({ dobRequired: true, ...(dob && { dobWrong: true }) }))
    } else if (response.status === NOT_FOUND) {
      dispatch(updateDeviceProfile({ profileNotFound: true }))
    } else {
      const profile = await response.json()
      dispatch(updateDeviceProfile({ profile }))
    }
  }
}
